module.exports = __webpack_public_path__ + "img/item_Story_24.f94eca1a.jpeg";